<script lang="ts">// prettier-ignore
const { children, class: className = '', ...rest } = $props();
export {};
</script>

<span {...rest} class="Badge {className}">
  {@render children?.()}
</span>

<!-- svelte-ignore css_unused_selector -->
<style>@charset "UTF-8";
@layer design-system-components.pwds {
  .Badge {
    border-radius: var(--badge-border-radius);
    font-family: var(--text-font-family);
    font-weight: var(--text-font-weight-medium);
    letter-spacing: var(--text-variant-50-letter-spacing);
    padding: var(--badge-padding);
    transform: translateY(var(--badge-translate-y));
    /*
    Typically we defer spacing to the parent element but for Badge, we assume:
      1. the display will always be inline-block
      2. the space to the right of the badge is always present
      3. the adjacent element might not be wrapped in a <span /> or a another element
    */
    display: inline-block;
    background-color: var(--color-text);
    color: var(--color-background);
    /*
    Fix for vertical text misalignment: Due to the small amount of padding around Badge text, the text is not vertically centered when an even amount of padding is applied to the top and bottom. Further, this misalignment is not consistent across browsers and across displays with various pixel densities. So, we can't simply rely on visually adjusting the padding to center the text.

    The following workaround is taken from https://seek-oss.github.io/capsize/ where these magic numbers are defined as tokens:
      --badge-font-cap-height - measured from Figma
      --badge-font-cap-multiplier – computed 1 time by capsize website
      --badge-font-cap-trim-top - trim space above cap height
      --badge-font-cap-trim-bottom - trim space below baseline

    When https://www.w3.org/TR/css-inline-3/#leading-trim ships, we can simplify this workaround.
    */
    line-height: var(--badge-font-cap-height);
    font-size: calc(var(--badge-font-cap-height) * var(--badge-font-cap-multiplier));
  }
  .Badge + * {
    margin-left: var(--badge-inline-spacing);
  }
  .Badge::before {
    content: "";
    margin-top: var(--badge-font-cap-trim-top);
    display: table;
  }
  .Badge::after {
    content: "";
    margin-bottom: var(--badge-font-cap-trim-bottom);
    display: table;
  }
  .Badge + :global(*) {
    margin-left: var(--badge-inline-spacing);
  }
}</style>
